export const configFirLayer = {
  "Name": "FIR",
  "Renderer": "FIRExt",
  "Attributes": {
    "features": [
      {
        "style": {
          "default": {
            "type": "polygon",
            "line_color": "#a79cff",
            "fill_color": "rgba(0,0,0,0)"
          }
        }
      }
    ]
  }
};